// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Labels = require("../../../reason/clients/components/Labels.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("./FragmentErrorBoundary.bs.js");
let AgentPropertyMlsStatus = require("./AgentPropertyMlsStatus.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ForSalePropertyStatus_forSalePropertyV5_graphql = require("../../../__generated__/ForSalePropertyStatus_forSalePropertyV5_graphql.bs.js");

let convertFragment = ForSalePropertyStatus_forSalePropertyV5_graphql.Internal.convertFragment;

function ForSalePropertyStatus$WithoutErrorBoundary(props) {
  let property = RescriptRelay_Fragment.useFragment(ForSalePropertyStatus_forSalePropertyV5_graphql.node, convertFragment, props.property);
  let match = property.status;
  let tmp;
  switch (match.__typename) {
    case "ExpiredProperty" :
      tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsx(Labels.ExpiredStatusLabel.make, {}),
          JsxRuntime.jsx(AgentPropertyMlsStatus.make, {
            property: property.fragmentRefs,
            size: props.size
          })
        ]
      });
      break;
    case "SoldProperty" :
      tmp = JsxRuntime.jsx(Labels.SoldLabel.make, {});
      break;
    case "UnderContractProperty" :
      tmp = JsxRuntime.jsx(Labels.UnderContractLabel.make, {});
      break;
    case "WithdrawnProperty" :
      tmp = JsxRuntime.jsx(Labels.WithdrawnLabel.make, {});
      break;
    case "ActiveProperty" :
    case "__unselected" :
      tmp = JsxRuntime.jsx(AgentPropertyMlsStatus.make, {
        property: property.fragmentRefs
      });
      break;
  }
  return JsxRuntime.jsx("div", {
    children: tmp,
    className: "flex gap-4"
  });
}

function ForSalePropertyStatus(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "property status",
    children: JsxRuntime.jsx(ForSalePropertyStatus$WithoutErrorBoundary, {
      property: props.property,
      size: props.size
    })
  });
}

let make = ForSalePropertyStatus;

exports.make = make;
/* Labels Not a pure module */
